/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ThreadInputs */

const en_thread = /** @type {(inputs: ThreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thread`)
};

const id_thread = /** @type {(inputs: ThreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utas`)
};

/** @type {(inputs: ThreadInputs) => LocalizedString} */
const es_thread = en_thread;

/** @type {(inputs: ThreadInputs) => LocalizedString} */
const fr_thread = en_thread;

/** @type {(inputs: ThreadInputs) => LocalizedString} */
const de_thread = en_thread;

/** @type {(inputs: ThreadInputs) => LocalizedString} */
const ja_thread = en_thread;

/** @type {(inputs: ThreadInputs) => LocalizedString} */
const zh_thread = en_thread;

/** @type {(inputs: ThreadInputs) => LocalizedString} */
const ar_thread = en_thread;

/** @type {(inputs: ThreadInputs) => LocalizedString} */
const it_thread = en_thread;

/** @type {(inputs: ThreadInputs) => LocalizedString} */
const ru_thread = en_thread;

/** @type {(inputs: ThreadInputs) => LocalizedString} */
const pt_thread = en_thread;

/** @type {(inputs: ThreadInputs) => LocalizedString} */
const ko_thread = en_thread;

/**
* | output |
* | --- |
* | "Thread" |
*
* @param {ThreadInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const thread = /** @type {((inputs?: ThreadInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ThreadInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_thread(inputs)
	if (locale === "es") return es_thread(inputs)
	if (locale === "fr") return fr_thread(inputs)
	if (locale === "de") return de_thread(inputs)
	if (locale === "ja") return ja_thread(inputs)
	if (locale === "zh") return zh_thread(inputs)
	if (locale === "ar") return ar_thread(inputs)
	if (locale === "id") return id_thread(inputs)
	if (locale === "it") return it_thread(inputs)
	if (locale === "ru") return ru_thread(inputs)
	if (locale === "pt") return pt_thread(inputs)
	return ko_thread(inputs)
});